/* eslint-disable prettier/prettier */
import CookieLib from '../helpers/cookieLib';
import Locales from './locales';
const RouteConstant = Locales.JSON.route;
const { region } = Locales;
export const RouteConfig = [
  {
    names: [
      {
        id: 1,
        name: RouteConstant.DASHBOARD,
        linkTo: '/dashboard',
        forUser: true,
        icon: 'home-active',
      },
      {
        id: 2,
        name: RouteConstant.INVOICE,
        linkTo: '/invoice/myinvoice',
        forUser: true,
        children:[3,4],
        icon: 'invoice',
        subSegment: [
          {
            name: RouteConstant.MY_INVOICES,
            id: 3,
            parentId:2,
            linkTo: '/invoice/myinvoice?tab=Saved&Count',
            forUser: true,
          },
          {
            name: RouteConstant.MY_APPROVAL,
            id: 4,
            parentId:2,
            linkTo: '/invoice/myapproval?tab=Pending',
            forUser: false,
          },
        ],
      },
      {
        id: 5,
        name: RouteConstant.VENDOR,
        linkTo: '/vendor/myvendor',
        forUser: true,
        children:[6,7],
        icon: 'vendor',
        subSegment: [
          {
            name: RouteConstant.MY_VENDOR,
            id: 6,
            parentId:5,
            linkTo: '/vendor/myvendor?tab=Saved&Count',
            forUser: true,
          },
          {
            name: RouteConstant.MY_VENDOR_APPROVAL,
            id: 7,
            parentId:5,
            linkTo: '/vendor/myapproval?tab=Pending',
            forUser: false,
          },
        ],
      },
    ],
  },
  {
    names: [
      {
        id: 8,
        name: 'Bill',
        linkTo: '/balance',
        forUser: false,
        icon: 'bills-active',
      },
    ],
  },
];

export const RouteMap = {
  '/dashboard': {
    open: false,
    showList: 1,
    showListItem: [-1],
    forUser: true,
  },
  '/invoice/myinvoice': {
    open: true,
    showList: 3,
    showListItem: [2],
    forUser: true,
  },
  '/invoice/myapproval': {
    open: true,
    showList: 4,
    showListItem: [2],
    forUser: false,
  },
  '/vendor/myvendor': {
    open: true,
    showList: 6,
    showListItem: [5],
    forUser: true,
  },
  '/vendor/myapproval': {
    open: true,
    showList: 7,
    showListItem: [5],
    forUser: false,
  },
  '/balance': {
    open: false,
    showList: 8,
    showListItem: [-2],
    forUser: false,
  },
};

export const routes = {
  '/': { name: 'Dashboard', path: '/dashboard' },
  '/invoice': { name: 'Invoice', path: '/expenses/myexpenses' },
  '/vendor': { name: 'Vendor', path: '/vendor/my-vendor' },
  // '/vendor/myvendor/:vendorType': params => params.vendorType,
  // '/expenses/:assignType': params => params.assignType,
  // '/expenses/myexpenses/:txnid': params => params.txnid,
};

export const nameTypeMap = {
  usedbyme: RouteConstant.MY_CARDS,
  assignedbyme: RouteConstant.ASSIGNED_CARDS,
  myexpenses: RouteConstant.MY_TRANSACTIONS,
  othersexpenses: RouteConstant.OTHERS_TRANSACTION,
};